/**
 * Project status domain type.
 *
 * Per the master specification (Section 14), statuses use stable internal IDs.
 * Display names may be edited later without breaking historical relationships;
 * the display string is never database identity.
 */
export interface ProjectStatus {
  /** Stable internal identifier (never the display name). */
  id: string;
  displayName: string;
  sortOrder: number;
  /** Seeded system statuses cannot be deleted by future configuration UIs. */
  isSystem: boolean;
}

/** Stable IDs of the statuses seeded by the initial migration. */
export const STATUS_IDS = {
  planning: "planning",
  active: "active",
  listed: "listed",
  underContract: "under-contract",
  sold: "sold",
  closed: "closed",
  archived: "archived",
} as const;
